<template>
    <transition
        v-bind:css="false"
        v-on:before-appear="beforeAppear"
        v-on:before-enter="beforeAppear"
        v-on:appear="appear"
        v-on:enter="appear"
        v-on:leave="leaveReverse"
        mode="out-in"
    >
        <slot>
        </slot>
    </transition>
</template>

<script>
import { TimelineLite, TweenLite, Power1, Back, Sine } from 'gsap';

export default {
    props: {
        animSpeed: {
            type: Number,
            default: 1
        }
    },

    data() {
        return {
            appearTimeline: new TimelineLite(),
            tween: TweenLite,
            show: true,
        }
        
    },

    methods: {
        beforeAppear(el, done) {
            this.tween.set(el, {
                opacity: 0,
            });
        },

        appear(el, done) {

            this.appearTimeline = new TimelineLite({
                onComplete: () => {
                    done();
                }
            })

            this.appearTimeline.to(el, 0.15 * this.animSpeed, {
                ease: Sine.easeOut,
                opacity: 1
            })
        },
        
        leaveReverse(el, done) {

            this.appearTimeline.eventCallback('onReverseComplete', () => {
                done();
            })
            this.appearTimeline.reverse();
        }
    }
    
}
</script>

<style lang="scss" >

</style>
